import { useNavigate, useLocation } from "react-router-dom";
import { Home, FileEdit, Car, FileText } from "lucide-react"; // Lucide icons

const EditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const sections = [
    {
      label: "Edit Home Page",
      description: "Modify banner, intro text",
      path: "/edit",
      icon: <Home className="w-8 h-8 text-blue-900" />,
    },
    {
      label: "Edit About Us",
      description: "Update team info, mission",
      path: "/edit/about",
      icon: <FileEdit className="w-8 h-8 text-blue-900" />,
    },
    {
      label: "Update Footer",
      description: "Edit social links, contact",
      path: "/edit/footer",
      icon: <FileText className="w-8 h-8 text-blue-900" />,
    },
    {
      label: "Add New Car",
      description: "Upload car details",
      path: "/cars/add",
      icon: <Car className="w-8 h-8 text-blue-900" />,
    },
  ];

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {sections.map((section) => {
          const isActive = location.pathname === section.path;
          return (
            <button
              key={section.path}
              onClick={() => !isActive && navigate(section.path)}
              disabled={isActive}
              className={`flex items-start gap-4 p-5 text-left bg-white  rounded-lg shadow hover:shadow-md transition ${
                isActive ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <div>{section.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  {section.label}
                </h3>
                <p className="text-sm text-gray-500">{section.description}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EditPage;
